module.exports = __webpack_public_path__ + "assets/img/26@3x.5b44b88f.png";